<template>
  <div class="tabs-container">
    <ul class="nav nav-tabs center-tabs">
      <li v-for="(tab, index) in tabs" :key="tab.title" :id="`tab-item-${titleToId(tab.title)}`" class="nav-item">
        <a :id="`tab-link-${titleToId(tab.title)}`" class="nav-link" :class="{
          'active': tab.isActive && !tab.disabled,
          'disabled': tab.disabled
        }" :href="tab.href" @click.prevent="handleTabClick(tab, index)" role="tab" :aria-selected="tab.isActive"
          :aria-disabled="tab.disabled">
          <slot :name="`tab-title-${titleToId(tab.title)}`">
            {{ tab.title }}
          </slot>
        </a>
      </li>
    </ul>
    <div class="tab-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',

  props: {
    value: {
      type: Number,
      default: 0
    },
    defaultTab: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      tabs: []
    }
  },

  created() {
    this.tabs = this.$children
  },

  mounted() {
    if (this.tabs.length) {
      this.selectTab(this.tabs[this.defaultTab], this.defaultTab)
    }
  },

  computed: {
    titleToId() {
      return (title) => title.toLowerCase().replace(/\s+/g, '-')
    }
  },

  methods: {
    handleTabClick(selectedTab, index) {
      if (!selectedTab.disabled) {
        this.selectTab(selectedTab, index)
      }
    },

    selectTab(selectedTab, index) {
      this.tabs.forEach((tab, idx) => {
        const shouldMount = idx === 0 || tab === selectedTab
        tab.isActive = tab === selectedTab

        if (shouldMount && !tab.isMounted) {
          tab.isMounted = true
        }
      })

      this.$emit('input', index)
      this.$emit('tab-changed', { tab: selectedTab, index })
      selectedTab.$emit('click', { tab: selectedTab, index })
    }
  }
}
</script>

<style scoped>
.tabs-container {
  width: 100%;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
  display: flex;
}

.nav-tabs .nav-link {
  position: relative;
  color: #4a5568;
  border: 1px solid #dee2e6;
  /* border-bottom: 1px solid; */
  transition: all 0.2s ease-in-out;
  background-color: #f9fafc;
}

.nav-tabs .nav-link.active {
  color: #020f40;
  font-weight: 500;
  background-color: #fff;
  border-bottom: 1px solid transparent;
}

.nav-tabs .nav-link:hover:not(.active):not(.disabled) {
  color: #4462ce;
  border-color: #e9ecef #e9ecef #dee2e6;
}

.nav-tabs .nav-link.disabled {
  color: #9ca3af;
  cursor: not-allowed;
  background-color: transparent;
  border-color: transparent;
}

.tab-content {
  padding: 0.5rem;
}

@media (max-width: 640px) {
  .nav-tabs {
    flex-wrap: wrap;
  }

  .nav-tabs .nav-link {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}
</style>
